import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCreateProjectRoute: InvariantJiraRoute = {
	name: 'servicedesk-create-project',
	path: '/jira/servicedesk/create-project',
	exact: true,
};
